// extracted by mini-css-extract-plugin
module.exports = {"container":"FlyoutSummary__container__3kjDR","item":"FlyoutSummary__item__1zamQ","media":"FlyoutSummary__media__1NfVO"};